// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q5FH8","col":"styles_col__JkRwP","actions":"styles_actions__2bKQ8","conflict":"styles_conflict__ItRTC"};